export default __webpack_public_path__ + "static/media/it.add46250.svg";